export default "__VITE_ASSET__D50Ionz6__"